import { render } from "./DirectoryComponent.vue?vue&type=template&id=0bb98f69&scoped=true"
import script from "./DirectoryComponent.vue?vue&type=script&lang=js"
export * from "./DirectoryComponent.vue?vue&type=script&lang=js"

import "./DirectoryComponent.vue?vue&type=style&index=0&id=0bb98f69&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb98f69"],['__file',"src/views/FAQManagement/components/DirectoryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bb98f69"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bb98f69', __exports__)) {
    api.reload('0bb98f69', __exports__)
  }
  
  module.hot.accept("./DirectoryComponent.vue?vue&type=template&id=0bb98f69&scoped=true", () => {
    api.rerender('0bb98f69', render)
  })

}


export default __exports__